import type { ProductDetail } from '@/types'
import { Tab } from '@headlessui/react'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import DrawCenter from '../DrawCenter/DrawCenter'
import ProductInformation from './ProductInformation'
import ProductReviewAndRateModal from './ProductReviewAndRateModal'
import { ProductSpecificationsModal } from './ProductSpecificationsModal'

interface ProductModalProps {
  productName: string
  productDetail: ProductDetail
  defaultIndex: number
  open: boolean
  onClose: () => void
  reviewSummary: number[]
  average: number
  onOpenCreateModal: () => void
}

export const ProductModal = ({
  productName,
  productDetail,
  defaultIndex = 0,
  onClose,
  open,
  reviewSummary,
  average,
  onOpenCreateModal,
}: ProductModalProps) => {
  const [index, setIndex] = useState(defaultIndex)
  const t = useTranslations()

  return (
    <DrawCenter open={open} onClose={onClose} title={productName}>
      <Tab.Group selectedIndex={index} onChange={setIndex}>
        <Tab.List className='-mx-5 mb-5 border-b border-b-[#D1D5DB]'>
          <Tab className='outline-0'>
            {({ selected }) => (
              <div
                className={`h-[40px] min-w-[180px] border-b-[5px] border-white px-5 text-sm text-main hover:border-b-link hover:font-semibold hover:text-link ${
                  selected && 'border-b-link font-semibold text-link'
                }`}
              >
                {t('ProductDetail.information')}
              </div>
            )}
          </Tab>
          <Tab className='outline-0'>
            {({ selected }) => (
              <div
                className={`h-[40px] min-w-[180px] border-b-[5px] border-white px-5 text-sm text-main hover:border-b-link hover:font-semibold hover:text-link ${
                  selected && '!border-b-link !font-semibold !text-link'
                }`}
              >
                {t('ProductDetail.specification')}
              </div>
            )}
          </Tab>
          <Tab className='outline-0'>
            {({ selected }) => (
              <div
                className={`h-[40px] min-w-[180px] border-b-[5px] border-white px-5 text-sm text-main hover:border-b-link hover:font-semibold hover:text-link ${
                  selected && 'border-b-link font-semibold text-link'
                }`}
              >
                {t('ProductDetail.review')}
              </div>
            )}
          </Tab>
        </Tab.List>
        <Tab.Panels>
          <Tab.Panel>
            <ProductInformation
              hideTitle
              description={productDetail.description}
              full
              className='!p-0'
            />
          </Tab.Panel>
          <Tab.Panel>
            <ProductSpecificationsModal
              specifications={productDetail.properties}
            />
          </Tab.Panel>
          <Tab.Panel>
            <ProductReviewAndRateModal
              productId={productDetail._id}
              reviewSummary={reviewSummary}
              average={average}
              onOpenCreateModal={onOpenCreateModal}
            />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </DrawCenter>
  )
}

export default ProductModal
